import { useContext } from 'react';
import { DiagnosticsContext } from './DiagnosticsContext';

export const useDiagnostics = () => {
  return useContext(DiagnosticsContext);
};
